import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";

export const ElCriteria = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-attachment: fixed; /* KEY for parallax */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElCriteriaContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2em;
  padding: 10px;
  /* align-items: center; */
  justify-content: flex-start;
`;

export const ElFooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 2em;
  padding: 2em 0 0 0;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  width: 33.33%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1em;
  text-align: left;
  height: 100%;
  h3 {
    color: #003562;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 25px */
    letter-spacing: -0.4px;
  }

  p {
    color: #003562;

    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    letter-spacing: -0.28px;
  }
  a {
    font-size: 15px;
    font-weight: 400;
    color: var(--theme-main-color);
  }
  ${isMobile} {
    width: 100% !important;
    height: auto;
    /* justify-content: center; */
    /* align-items: center; */
    flex: none !important;
  }
`;

export const ElActionList = styled.div``;

export const ElImage = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
  object-fit: contain;

  border-radius: 5px;
`;

export const elGapCriteria = css`
  gap: 20px;
  position: relative !important;
  z-index: 2 !important;
`;

export const elBgWhite = css`
  /* background-color: #fff; */
  /* box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.18); */
  border-radius: 10px;
`;
